import { useState } from 'react'
import '../styles/Footer.css'
import { BUILD_TIMESTAMP } from '../timestamp';

function Footer() {
	const [inputValue, setInputValue] = useState('')

    function handleInput(e) {
		setInputValue(e.target.value)
	}

	function handleBlur() {
		if (!inputValue.includes('@')) {
			alert("Attention, il n'y a pas d'@, ceci n'est pas une adresse valide 😥")
		}
	}

    const buildVersion = 'Beta ' + BUILD_TIMESTAMP; //(process.env.REACT_APP_BUILD_TIME || '');

    return (
        <footer className='kdo-footer'>
            &copy; 2025 Listaki - Tous droits réservés - Liens affiliés
            <a
            href="https://listaki.fr/cgu/"
            target="_blank"
            rel="noopener noreferrer"
            className="kdo-button-like-link"
          >
            CGU
          </a>
            <a
            href="https://listaki.fr/politique-confidentialite/"
            target="_blank"
            rel="noopener noreferrer"
            className="kdo-button-like-link"
          >
            Confidentialité
          </a>
            <span className='kdo-footer-version'>Version: {buildVersion}</span>
            
        </footer>
    )
}

export default Footer